import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Link from './links'
import * as serviceWorker from './serviceWorker';

ReactDOM.render(<Link />, document.getElementById('root'));

serviceWorker.unregister();
